import {SimplePresentation} from "./SimplePresentationRunner";
import {Possessed} from "../../Possessed";
import {PossessedSymbol} from "../../reels/PossessedSymbol";
import {SimpleReelModelState} from "../../../core/reel/simplereel/SimpleReelModel";
import {PossessedSymbolFactory} from "../../reels/PossessedSymbolFactory";

export class MysteryRevealPresentation extends SimplePresentation {
    constructor() {
        super("HotZone Symbol Presentation");
    }

    shouldRun(): boolean {
        return Possessed.model.gameData?.hotZoneSize > 0;
    }

    protected skip() {

    }

    buildTimeline() {
        const tl = this.tl;
        this.controller.setSkipCallback(this.skip);

        const stopReversed = Possessed.model.triggeredFreespins() || (Possessed.model.isFreespins());

        const isFullCrossSymbol = Possessed.model.hasFullCrossSymbol() && Possessed.model.getFullCrossSymbolName() != "W";

        // Only replace symbols in freespin or respin.. otherwise we will replace symbols as soon as the hotzones are activated.
        if(!(Possessed.model.isFreespins() || Possessed.model.isRespin())) return;
        
        if(isFullCrossSymbol) {
            const mysteryReels = Possessed.reelView.reelCross.getActiveMysteryReels();
            mysteryReels.forEach(reel => reel.isFullCross = true);
        } else {
            const mysteryReels = Possessed.reelView.reelCross.getActiveMysteryReels();
            mysteryReels.forEach(reel => reel.isFullCross = false);
        }

        const hotZoneSymbols = Possessed.model.getHotZoneSymbols().map(sym => {
            const symbol = PossessedSymbolFactory.createSymbol(sym.symbol, sym.reelID, sym.reelPosition);
            if(isFullCrossSymbol) {
                symbol.turnIntoFullCross();
            }
            symbol.visible = false;
            return symbol;
        });

        hotZoneSymbols.forEach((s, index) => {
            tl.add(() => {
                Possessed.reelView.replaceSymbolAt(s.reelID, s.reelPosition, s);
                s.visible = true;
            }, "<")
        })
        tl.add(Possessed.reelView.reelCross.stopMysteryReels(stopReversed, hotZoneSymbols.length ? hotZoneSymbols[0].name : Possessed.model.data.xCrucifixReel[0]));
        //tl.add(() => {
        //    Possessed.reelView.reelCross.stopMysteryReels(stopReversed, hotZoneSymbols[0].name);
        //}, "<")



        //for(let i:number=0;i<hotZoneSymbols.length; i++) {
        //    let sym = hotZoneSymbols[i];
        //    const oldSym = Possessed.reelView.getSymbolAt(sym.reelID, sym.reelPosition);
        //    const newSym:PossessedSymbol = Possessed.reelView.createSymbol(sym.symbol, SimpleReelModelState.IDLE, sym.reelID, sym.reelPosition);
        //    newSym.visible = false;

        //    const mysteryReel = Possessed.reelView.reelCross.getMysteryReel(sym.reelID, sym.reelPosition);
        //    if(mysteryReel) {
        //        tl.add(() => {
        //           mysteryReel.stop(newSym.name, 0.3, stopReversed);
        //           Possessed.reelView.reelCross.setFireStaticAnimationAtReel(mysteryReel.reelID);
        //           newSym.visible = true;
        //            Possessed.reelView.replaceSymbolAt(newSym.reelID, newSym.reelPosition, newSym);
        //            if(Possessed.model.hasFullCrossSymbol() && newSym.name != "W") {
        //                Possessed.reelView.getSymbolAt(newSym.reelID, newSym.reelPosition).turnIntoFullCross();
        //            }
        //        }, i == 0 ? ">0.3" : "<");
        //    }
        //}

        //Padding
        if(hotZoneSymbols.length) {
            tl.add(() => {}, ">0.2");
        }
    }
}